<div class="container mt-3">
    <div class="main">
        <h1>Ver producto</h1>
        <hr>
        <form [formGroup]="form" (ngSubmit)="postSale()" class="row justify-content-center paper">
            <div *ngIf="loading"  class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            <div *ngIf="!loading" class="m-1 col-md-5 col-sm-12 ">
                <img class="product-img" [src]="product.imgUrl">
            </div>
            <div class=" m-1 col-md-5 col-sm-12 col-lg-6">
                <h2><b>{{product.name}}</b><span class="ml-3 badge badge-info">{{product.category}}</span>
                </h2>
                <hr>
                <div *ngIf="product.discount" >
                    <span class="card-title">${{getPrice}}</span>
                    <del class="text-discount">${{product.price}} </del>
                </div>
                <h3 *ngIf="!product.discount" class="card-title">${{product.price}}</h3>
                <h5>{{product.description}}</h5>
                <br>
                <div class="row">
                    <div class="col col-form-label">
                        <h5>Disponible en </h5>
                        <h6 *ngIf="!activeSize" class="text-danger">Debes elegir talle</h6>
                    </div>
                    <div class="col">
                        <h2><span (click)="activateSize(talle)"
                            *ngFor="let talle of product.talles" 
                            class="pointer m-1 badge bg-secondary"
                            [ngClass]="{'background-primary' : activeSize === talle}">
                            {{talle}}
                        </span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-form-label"><h5>Cantidad</h5></div>
                    <div class="col">
                        <input [class.is-invalid]="notValidAmount" class="form-control"type="number" formControlName="amount">
                        <small *ngIf="notValidAmount" class="text-danger">La cantidad debe estar entre 1 y 5</small>
                        <br>
                    </div>
                </div>
                <div class="row">
                    <button [class.disabled]="!form.valid || !activeSize" class=" btn btn-block brown">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cart-plus" viewBox="0 0 16 16">
                            <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"/>
                            <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                        </svg>
                        Agregar al carrito
                    </button>
                </div>
            </div>
        </form>
        <h2 class="container mt-5">Quienes compraron {{product.name}} tambien compraron...</h2>
        <hr>
        <app-trending-products></app-trending-products>
    </div>
</div>